import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import * as moment from "moment";
import {DaterangepickerDirective} from 'ngx-daterangepicker-material';
import { saveAs } from 'file-saver';
import { ImageResult } from 'ngx-image2dataurl';
import { ToastrService } from 'ngx-toastr';
import { LocalStorage } from 'ngx-store';

//Model
import { Service } from './../../../model/maintenance.model';
import { Url } from '../../../model/users.model';

//Service
import { MaintenanceService} from './../../../services/maintenance.service';
import { FilesService } from './../../../services/files.service';
import { FleetAssetsService } from '../../../services/fleetassets.service';
import { ExportService } from '../../../services/exporter.service';
import { ThemeSetting } from '../../../model/users.model';
import { FileExport } from '../../../model/exporter.model';

@Component({
    selector: 'app-service',
    templateUrl: './service.component.html',
    styleUrls: ['../../datatable.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [MaintenanceService, FilesService, FleetAssetsService]
  })
  

  export class ServiceComponent implements OnInit {
    @LocalStorage() url!: Url;
    @LocalStorage() themeSettings: ThemeSetting;

    public fileStoragePath = this.url.fileStorage;
    public readonly folderPath = this.fileStoragePath + '/service/';

    service_rows = [];
    selected4 = [];

    drivers = [];
    fleet = [];
    providers = [];
    showSidebar: boolean = true;

    public serviceForm: FormGroup;
    public modalRef: NgbModalRef;
    public valueToolTip: any;

    public service: Service;
    public isEditMode: boolean = false;

    loadingIndicator1: boolean = true;
    reorderable: boolean = true;

    public prefixService :string = "service";
    v

    public title : string;
    public objToDelete: any;
    public fileToDelete: string;

    public driver_id: any;
    public frmFile: any;
    public fileExists :boolean;
    public fileRemove :boolean;
    public oldFile: string;

    private caller : string ='';
    private modalCaller: string;

    loading_indicator1 : boolean= true;

    public prefix_fleet = "fleetdetails";

    serviceYearly: number;
    serviceMonthly: number;
    serviceWeekly: number;
    serviceRecentCost: number;
    serviceRecentRego: string;
    serviceRecentDate: string;

    summaryCount = 0;
    summaryTotalCost = 0;

    showDate:boolean=true;
    showRego:boolean=true;
    showFleetType:boolean=true;
    showDescription:boolean=true;
    showServiceInterval:boolean=true;
    showOdometer:boolean=true;
    showSupplier:boolean=true;
    showCost:boolean=true;
    showReceiptNo:boolean=true;
    showFile:boolean=true;

    myDropDown='7';
    dateFilter='Last 7 Days';

    //Handles the name, type and content of the to-be exported file
    public exp_excel: FileExport;
    public exp_pdf: FileExport;

    //Stores the filtered and formatted content of the file
    formatted_list : any;

    public serviceDateRange: any =[];
    locale: any = {
      format: 'DD MMMM YYYY',
      displayFormat: 'DD MMMM YYYY',
      separator: ' to ',
      cancelLabel: 'Cancel',
      applyLabel: 'OK',
    }
    maxDate: moment.Moment = moment();

    totalServiceAmount: any;
    totalService: number = 0;
    averageServiceAmount: any;
    spinner: boolean = false;


    @Input() services: Service[];
    @Input() parent: string;
    @Input() fleet_id :number; 
    @Output() refreshData : EventEmitter<any>= new EventEmitter<any>();
    @ViewChild('modalService', { static: false }) modalService: TemplateRef<any>;
    @ViewChild(DaterangepickerDirective, {static: false}) daterangepicker: DaterangepickerDirective;

    constructor(private http: HttpClient, 
                private modal: NgbModal, 
                private _fb: FormBuilder, 
                private maintenanceService: MaintenanceService, 
                private fileService: FilesService,
                private toastr: ToastrService,
                private fleetAssetsService: FleetAssetsService,
                private exporter: ExportService){

    }

    ngOnInit() {
        this.initServiceForm();
        this.resetFileVariables();
        this.getServices(this.myDropDown); 

        //Declaration to handle the name, type and content of the file
        this.exp_excel = {title:'', list_data:'', type:''};
        this.exp_pdf = {title:'', list_data:'', type:''};
    }

    service_columns = [
      { prop: 'date_done' },
      { prop: 'Rego' },
      { prop: 'fleet_type' },
      { prop: 'description' },
      { prop: 'mileage' },
      { prop: 'cost' },
      { prop: 'file' },
      { prop: 'current_odometer' },
      { prop: 'service_interval' },
      { prop: 'klms_next_service' },
      { prop: 'receipt_no' },
    ];

    initServiceForm() {
      const currencyRegex = '^[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$';
      const numbers = '^[0-9]+$'; 
      const floatRegex = '[+-]?([0-9]*[.])?[0-9]+';

      this.serviceForm = this._fb.group({
        id: [''],
        date_done: ['', Validators.required],
        time_done: [''],
        time_string: [{hour: 1, minute: 30}],
        fleet_id: ['', Validators.required],
        provider_id: ['', Validators.required],
        file: [''],
        service_description: ['', Validators.required],
        receipt_no: [''],
        driver_id: [''],
        hours: ['', Validators.pattern(floatRegex)],
        fault: [''],
        cost: ['', [Validators.required, Validators.pattern(currencyRegex)]],
        note: [''],
        mileage :['', [Validators.required, Validators.pattern(numbers)]],
      });
    }

    isCost() {
      const frmCtrl = (<any>this.serviceForm);
  
      if (frmCtrl.controls.cost.valid)
        return true;
      else return false;
    }

    onSelect4({ selected }) {
    }

    getServices(myDropdown,start='', end='') {
      setTimeout(() => { this.loading_indicator1 = false }, 500);
      if (this.fleet_id) {
        this.maintenanceService.getServicesByFleetId(this.fleet_id.toString(),myDropdown,start,end).toPromise().then(data => {
          this.service_rows = data['services'];
          this.fullRowsServices = this.service_rows;
          this.tempServices = this.service_rows;
          if(this.service_rows.length>0 && this.service_rows != null){
          this.selected4 = [this.service_rows[0]];
          this.serviceCount = Object.keys(this.service_rows).length;
          }
          else{
            this.selected4=[];
          }
          this.computeServiceSubtotals();
          this.computeNextKlmsService(this.service_rows);

        });
      }
      else {
        this.maintenanceService.getServices(myDropdown,start, end).toPromise().then(data => {
          this.service_rows = data['services'];
          this.fullRowsServices = this.service_rows;
          this.tempServices = this.service_rows;
          if(this.service_rows.length>0 && this.service_rows != null){
            this.selected4 = [this.service_rows[0]];
            this.serviceCount = Object.keys(this.service_rows).length;
          }else{
            this.selected4=[];
          }
          this.computeServiceSubtotals();
          this.computeNextKlmsService(this.service_rows);
        });
      }

        this.http.get(this.url.rest + '/tms/getMaintenanceMisc').subscribe(data => {
            this.drivers = data["drivers"];
            this.fleet = data["fleet"];
            setTimeout(() => { this.loading_indicator1 = false });
          });
        
          this.fleetAssetsService.getProvidersRepairsServices().subscribe(data =>{
            this.providers = data['providers'];
          });

          this.getServicesSummary();

          setTimeout(() => { this.loading_indicator1 = false });
    }

    onChangeofOptions(selected) {
      console.log('changing to', selected);
      if (selected == 'week') {
          this.myDropDown =  'week'
          this.dateFilter = 'This Week'
          this.showFilters = false;
          this.getServices(this.myDropDown);
      }
      else
      if (selected == 'month') {
          this.myDropDown =  'month'
          this.dateFilter = 'Month'
          this.showFilters = false;
          this.getServices(this.myDropDown);
      }
      else 
      if (selected == 'year') {
          this.myDropDown =  'year'
          this.dateFilter = 'This Year'
          this.showFilters = false;
          this.getServices(this.myDropDown);
      }
      else
      if (selected == 'today') {
          this.myDropDown =  'today'
          this.dateFilter = 'Today'
          this.showFilters = false;
          this.getServices(this.myDropDown);
      }
      else
      if (selected == '7') {
          this.myDropDown =  '7'
          this.dateFilter = 'Last 7 Days'
          this.showFilters = false;
          this.getServices(this.myDropDown);
      }
      else
      if (selected == '14') {
          this.myDropDown =  '14'
          this.dateFilter = 'Last 14 Days'
          this.showFilters = false;
          this.getServices(this.myDropDown);
      }
      else
      if (selected == '30') {
          this.myDropDown =  '30'
          this.dateFilter='Last 30 Days'
          this.showFilters = false;
          this.getServices(this.myDropDown);
      }
      else
      if (selected == '90') {
          this.myDropDown =  '90'
          this.dateFilter = 'Last 90 Days'
          this.showFilters = false;
          this.getServices(this.myDropDown);
      }
      else
      if (selected == 'range') {
          this.myDropDown =  'range'
          this.dateFilter = 'range'
          this.showFilters = true;
          // this.getServices(this.myDropDown);
          this.processServiceDateRange('');
      }
      else if(selected == "all") {
        this.showFilters = true;
        this.getServices("");
      }
    }

    processServiceDateRange(event) {
      console.log('processing range');
      // if (event.start != undefined && event.end != undefined){
        var start = moment(this.serviceDateRange.start?._d).format('YYYY-MM-DD');
        var end = moment(this.serviceDateRange.end?._d).format('YYYY-MM-DD');
      console.log(start + ' to ' + end);
      this.getServices('range',start, end);
      // }
    }

  computeServiceSubtotals() {
    this.totalServiceAmount = 0;
    this.totalService = 0;
    if (this.service_rows && this.service_rows.length > 0) {
        let sum: number = this.service_rows.map(a => a.cost).reduce(function(a, b)
        {
        return a + b;
        });
        this.totalServiceAmount = sum;

        this.totalService = this.service_rows.length;
    }
    this.averageServiceAmount = (this.totalServiceAmount / this.totalService) || 0;
  }

    getServicesSummary(){
      if (this.fleet_id) {
        this.maintenanceService.getServiceSummaryByFleetId(this.fleet_id).subscribe(data => {
          this.serviceYearly = data['service_yearly'];
          this.serviceMonthly = data['service_monthly'];
          this.serviceWeekly = data['service_weekly'];
          this.serviceRecentCost = data['service_recent_cost'];
          if( data['service_recent_rego'] !== null){
            this.serviceRecentRego = data['service_recent_rego']['fleet_id_num'] + '(' + data['service_recent_rego']['rego']  + ')';
          }else{ this.serviceRecentRego = '-';};
          this.serviceRecentDate = data['service_recent_date'];
        });
      }else{
        this.maintenanceService.getServiceSummary().subscribe(data => {
          this.serviceYearly = data['service_yearly'];
          this.serviceMonthly = data['service_monthly'];
          this.serviceWeekly = data['service_weekly'];
          this.serviceRecentCost = data['service_recent_cost'];
          if( data['service_recent_rego'] !== null){
            this.serviceRecentRego = data['service_recent_rego']['fleet_id_num'] + '(' + data['service_recent_rego']['rego']  + ')';
          }else{ this.serviceRecentRego = '-';};
          this.serviceRecentDate = data['service_recent_date'];
        });
      }  
    }

    public createService(service: Service) {
      this.spinner = true;
        this.maintenanceService.createService(service).subscribe(service => {
        this.getServices(this.myDropDown);   
        });
        this.spinner = false;
    }

    public updateService(service: Service) {
        this.spinner = true;
        this.maintenanceService.updateService(service).subscribe(service => {
        this.getServices(this.myDropDown);  
        });
        this.spinner = false;
    }
  
    async deleteService(id: number) {
      this.spinner = true;
      await this.maintenanceService.deleteService(id).toPromise().then(res => {
            this.toastr.success('', res["message"], {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
              });
          
        }).catch(err =>{
          this.toastr.error("Please try again.", "There was a problem with deleting the selected service record", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });         
        this.getServices(this.myDropDown);
        this.modalRef.close();
        this.refreshData.emit();  
        this.spinner = false;     
    } //END OF FLEET-18


    openServiceModal(service: Service): void {
      if(service){
        this.isEditMode = true;
        this.service = service;
        this.service['time_string'] = {hour: this.service['hour'], minute: this.service['minute']};
        this.serviceForm.patchValue(this.service);

        if (this.service.file !== null && this.service.file !== '')
          {
            this.oldFile = this.service.file;
            this.fileExists = true;
          }
      } 
      else{
        this.isEditMode = false;
        this.service = new Service();
        this.serviceForm.reset();

        //fleet_id is preset if come from fleetdetails component
        var fleet_value = '';
        if(this.fleet_id){fleet_value = this.fleet_id.toString();};
        this.serviceForm.controls.fleet_id.setValue(fleet_value);
        
      }   
      this.modalRef = this.modal.open(this.modalService, { size: 'lg', backdrop: 'static'});
    
      this.modalRef.result.then((result) => {
        this.serviceForm.reset();
      }, (reason) => {
        this.serviceForm.reset();
      });
    }

    showInvalidDateToastr(){
      this.toastr.error('', 'Entered an invalid date!', {
        timeOut: 2000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    }

    verifyDateValuesService(){
      if( (this.serviceForm.value.date_done != "" && !moment(this.serviceForm.value.date_done, "YYYY-MM-DD", true).isValid()) ){
          return false;
      }
      else return true;
    }
  
    async onSubmitService(service: Service) {
      if(this.verifyDateValuesService()){
        this.spinner = true;
        this.service = service;
        if (this.service.time_done)
          this.service['time_done'] = this.service['time_string'].hour + ":" + this.service['time_string'].minute + ":00";
        else this.service.time_done = '01:00:00';
      
        if (this.serviceForm.valid) {
          if(service.id){
        await this.maintenanceService.updateService(service).toPromise().then(res => {
                this.toastr.success('', res["message"], {
                  timeOut: 3000,
                  positionClass: 'toast-top-full-width',
                  progressBar: true
                });
            }).catch(err =>{
              this.toastr.error("Please try again.", "There was a problem with updating the selected service record", {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
              });
            }); 
            this.getServices(this.myDropDown);
            console.log('updating service...');
          }
          else{
        await this.maintenanceService.createService(service).toPromise().then(res => {
            this.toastr.success('', res["message"], {
              timeOut: 3000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          }).catch(err =>{
            this.toastr.error("Please try again.", "There was a problem with creating new service record", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          });
          console.log('creating service...');
          this.getServices(this.myDropDown);   
          }   
          this.uploadFile(this.prefixService, this.service.file);

          this.modalRef.close();
          this.refreshData.emit(); 
          this.spinner = false;   
        }
      }
      else this.showInvalidDateToastr();
    }

     public formatDate(inDate: string) {
      let formatedDate: Date;
      formatedDate = new Date(inDate.replace(/-/g, "/"));
      return formatedDate;
    }

    openDeleteObjModal(obj, caller, modalName): void {
      if(obj){
        switch (caller){
          case this.prefixService:{ this.service = obj; this.title = "Service"; this.fileToDelete = obj.file; break}
          default: break;
        }
      }
      this.objToDelete = obj;
      this.modalRef = this.modal.open(modalName, { size: 'sm', backdrop: 'static'});
    }

    public deleteObj(objToDelete) {
        this.spinner = true;
        let caller;

        switch (this.title){
            case 'Service' : {caller = this.prefixService;break;};
            default: {break;};
        }

        if(objToDelete.file != null && objToDelete.file != ''){
        this.deleteFile(caller, objToDelete.file);}
     
      switch(caller){
        case this.prefixService : {
          this.deleteService(objToDelete.id);
          this.getServices(this.myDropDown);
          break;
          }
        default: {break;};
      } 
      
      this.modalRef.close();
      this.fileToDelete = '';       
      this.refreshData.emit();
      this.spinner = false;
    }

    public deleteFile(caller, filename){
      this.fileService.deleteFile(caller, filename).subscribe(result=>{console.log(result);})
        this.fileRemove = false;
          this.refreshData.emit();
    }

     print(elementId: string): void {
      let printContents, popupWin;
      printContents = document.getElementById(elementId).innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
        <html>
        <head>
        <title>Maintenance - Services</title>
        <style>
        @page {
          size: A4;
        }

        table {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;
          border: 1px solid #ddd !important;
      }

      th, td {
          text-align: left;
          padding: 16px;
      }

      tr:nth-child(even) {
          background-color: #f2f2f2 !important;
          box-shadow: inset 0 0 0 1000px #f2f2f2;
      }

      .fn {
        float: footnote;
      }

      thead {
        box-shadow: inset 0 0 0 1000px #f2f2f2;
      }
             
      </style>
      </head>
      <body onload="window.print();window.close()">${printContents}</body>
        </html>`
      );
      popupWin.document.close();
    }

    //file functions
     public getFile(event, caller){

      var imgFilename;

      if (event == '' || event == null){
        imgFilename = event
      }else{
        var file : ImageResult;
        file = event;
        imgFilename =  file.file.name;

        this.frmFile = event;
      }

      switch (caller){
        case this.prefixService: 
          { this.serviceForm.controls.file.setValue(imgFilename); break;};
        
        default: break;
      }
    }

    public uploadFile(caller, filename){
      if (this.frmFile){
        this.fileService.uploadRawFile(caller, this.frmFile, filename).subscribe(file=>{
          console.log('file uploaded....');
        });
        
      }

      this.frmFile = '';

      //handling files if replaced, old file is removed from server
        if(this.fileRemove == true){
            this.deleteFile(caller, this.oldFile);
        };
    }

    public resetFileVariables(){
       // for document file handling variables; checking if file exists or removed
          this.fileExists = false;
          this.fileRemove  = false;
          this.oldFile = '';
    }

    public removeFile(caller){
      this.fileExists  = false;

      switch (caller){
      case  this.prefixService:
        { this.serviceForm.controls.file.setValue(''); break;};
      default: break;
      }
      
      this.fileRemove = true;
  }


  showFilters: boolean = false;
  
  filterServiceProvider: string = '';
  filterServiceRego: string = '';
  filterServiceDateFrom: Date;
  filterServiceDateTo: Date;


  isFilterEmpty: boolean = true;
  tempServices = [];
 
  fullRowsServices = [];
  
  serviceCount = 0;
  
  public toggleFilters() {
    if (this.showFilters) this.showFilters = false;
    else this.showFilters = true;
  }

  updateFilter(caller) {
    this.isFilterEmpty = false;

    switch (caller){

      case this.prefixService :{

        this.tempServices = this.fullRowsServices.filter(data => {
         if (this.filterServiceProvider && data.provider_id){
            return data.provider_id == this.filterServiceProvider;    
          }else{
            return data.provider_id;
          }
        });

        this.tempServices = this.tempServices.filter(data => {
          if (this.filterServiceRego && data.rego){
            return data.rego.toLowerCase().indexOf(this.filterServiceRego.toLowerCase()) !== -1 || !this.filterServiceRego.toLowerCase();    
          }else{
            return data.rego;
          }
        });
     
        this.getServiceSummary(this.tempServices)
        this.service_rows = this.tempServices;
        this.serviceCount = Object.keys(this.tempServices).length;

        if(this.service_rows.length>0){
          this.selected4 = [this.service_rows[0]]
        }else{
          this.selected4 = [];
        }

        this.totalServiceAmount = 0;
        this.totalService = 0;
        if (this.service_rows[0]) {
          let sum: number = this.service_rows.map(a => a.cost).reduce(function(a, b)
          {
            return a + b;
          });
          this.totalServiceAmount = sum;
          this.totalService = this.service_rows.length;
        }
        this.averageServiceAmount = (this.totalServiceAmount / this.totalService) || 0;
      }
      default: {break;}
    }
  }

 public resetFilters() {
  this.filterServiceProvider = '';
  this.filterServiceDateFrom = null;
  this.filterServiceDateTo = null;
  this.filterServiceRego = '';
  this.service_rows = this.fullRowsServices;

  if(this.service_rows.length>0){
    this.selected4 = [this.service_rows[0]]
  }else{
    this.selected4 = [];
  }

  this.isFilterEmpty = true;
  this.summaryCount = 0;
  this.summaryTotalCost = 0;
  this.serviceDateRange=[];
  this.getServices(this.myDropDown)
}

  public modalClose() {
    this.fileExists = false;
    this.modalRef.close();
  } 

  private action: string;
  
  getCellClass({ row, column, value }): any {
    return {
      'is-pending': row.status_id == '1',
      'is-completed': row.status_id == '3',
      'is-processing': row.status_id == '2',
    };
  }

  toggleSideBar(){
    if(this.showSidebar== true){
      this.loading_indicator1 = true;
      this.showSidebar = false;
      setTimeout(() => { this.loading_indicator1 = false; }, 100);

    }else{
      this.loading_indicator1 = true;
      this.showSidebar = true;
      setTimeout(() => { this.loading_indicator1 = false; }, 100);

    }
    this.getServices(this.myDropDown);

  }

  computeNextKlmsService(services){
    if(services){
      let change_fleet = 1;
      services.forEach(s=>{
        let next_klms_service='';
        let computed_klms_service = 0;
        let mileage1 = 0;
        let mileage2 = 0;
        

        mileage1 = s.mileage;
        let next_index = services.indexOf(s) + 1;
        
        if(services[next_index]){
          if(s.fleet_id == services[next_index].fleet_id){
            mileage2 = services[next_index].mileage;
          }
        }
        
        if(change_fleet == 1){
          // computation for first service record for a fleet.
          computed_klms_service = (mileage1 + s.service_interval) - s.current_odometer
          if( computed_klms_service < 0){
            next_klms_service = 'Missed service by ' + (computed_klms_service * -1).toString() + ' klms'
          }else{
            next_klms_service = computed_klms_service.toString() + ' klms';
          }
        }else{

          // computation succeeding services record for a fleet.
          computed_klms_service = mileage1 - mileage2; 
          if(computed_klms_service > s.service_interval){
            computed_klms_service = computed_klms_service - s.service_interval
            next_klms_service = 'Missed service by ' + computed_klms_service.toString() + ' klms';
          }else{
            next_klms_service = computed_klms_service.toString() + ' klms';
          }
        }

        if(services[next_index]){
          if(s.fleet_id != services[next_index].fleet_id){
            change_fleet = 1;
          }else{
            change_fleet++;
          }
        }
        s.next_klms_service = next_klms_service;

      })
    }
    return services;    
  }

    public getServiceSummary(tempServices){
    this.summaryTotalCost = 0; this.summaryCount = 0;
    if(tempServices.length === this.fullRowsServices.length){
      this.summaryTotalCost = 0;
      this.summaryCount = 0;    
    } else {
      for(let i = 0; i < tempServices.length; i++){
        this.summaryTotalCost = this.summaryTotalCost + tempServices[i].cost;
      }
      this.summaryCount = tempServices.length;
    }
  }

/*** Export... Module ***/
  //Replaces an attribute name for reading comprehension
  renameKey( obj, oldKey, newKey ) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }

  //Formats readable header names in the given table
  generateHeaders(list_services): any{
    const arr = JSON.parse(list_services);
    arr.forEach( obj => {
      this.renameKey( obj, 'date_done', 'Date' );
      this.renameKey( obj, 'rego', 'Rego' );
      this.renameKey( obj, 'fleet_type', 'Fleet Type' );
      this.renameKey( obj, 'service_description', 'Description' );
      this.renameKey( obj, 'mileage', 'Odometer' );
      this.renameKey( obj, 'next_klms_service', 'Service Interval' );
      this.renameKey( obj, 'provider', 'Supplier' );
      this.renameKey( obj, 'cost', 'Cost' );
      this.renameKey( obj, 'receipt_no', 'Receipt No' );
      this.renameKey( obj, 'file', 'File' );}
    );
    const updatedJson = JSON.stringify( arr );
    return updatedJson;
  }

  //Filters every column in the table list
  services_generateColumnsWithFilter(list_services){
    const arr = JSON.parse(JSON.stringify(list_services));
    arr.forEach( obj => {
      //Merge Fleet type and its subtype in the list
      obj['fleet_type'] =  obj['fleet_type'] + ' - ' + obj['subtype'];

      obj['date_done'] = formatDate(obj['date_done'], 'dd MMM yyyy', 'en_US');
      //remove filtered columns
      if(!this.showDate){
        delete obj['date_done']; 
      };
      if(!this.showRego){
        delete obj['rego'];
      };
      if(!this.showFleetType){
        delete obj['fleet_type'];
      };
      if(!this.showDescription){
        delete obj['service_description'];
      };
      if(!this.showOdometer){
        delete obj['mileage'];
      };
      if(!this.showServiceInterval){
        delete obj['next_klms_service'];
      };
      if(!this.showSupplier){
        delete obj['provider'];
      };
      if(!this.showCost){
        delete obj['cost'];
      };
      if(!this.showReceiptNo){
        delete obj['receipt_no'];
      };
      if(!this.showFile){
        delete obj['file'];
      };
      delete obj['id'];
      delete obj['fleet_id'];
      delete obj['provider_id'];
      delete obj['subtype'];
      delete obj['time_done'];
      delete obj['hours'];
      delete obj['fault'];
      delete obj['driver_id'];
      delete obj['note'];
      delete obj['created_at'];
      delete obj['updated_at'];
      delete obj['service_interval'];
      delete obj['current_odometer'];
      delete obj['hour'];
      delete obj['minute'];
    });
    const updatedJson = JSON.stringify( arr );
    return updatedJson;                    
  }

  //Exports  table to CSV file
  services_exportToCSV(){
    if(this.service_rows.length >0){
      let with_header_format, with_column_filter;
      
      //generate json with filtered column
      with_column_filter = this.services_generateColumnsWithFilter(this.service_rows);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let csv_file = '[TMS]Fleet_Maintenance_Services_' + this.formattedDate(current_date);
      this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Fleet Maintenance - Services');
    }
  };

  //Exports table to PDF file
  services_exportToPDF(){
    if(this.service_rows.length >0){
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.services_generateColumnsWithFilter(this.service_rows);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let pdf_file = '[TMS]Fleet_Maintenance_Services_' + this.formattedDate(current_date);
      this.exp_pdf.title = 'SERVICES';
      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
        saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
    }
  };
  
  //Exports table to MS Excel file
  services_exportToExcel(){
    if(this.service_rows.length >0){
      let with_header_format, with_column_filter;
      
      //generate json with filtered column
      with_column_filter = this.services_generateColumnsWithFilter(this.service_rows);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let excel_file = '[TMS]Fleet_Maintenance_Services_' + this.formattedDate(current_date);
      this.exp_excel.title = 'SERVICES';
      this.exp_excel.type = 'xlsx';
      this.exp_excel.list_data = this.formatted_list;
      this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
        console.log(data);
        saveAs(data, excel_file)

      });
    }
  };

  //Returns a date format in the file name
  public formattedDate(d = new Date) {
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return `${day}/${month}/${year}`;
  }
}